import { AlertDialog } from '@homeexchange/design';
import React from 'react';
var ErrorDialog = function (_a) {
    var title = _a.title, isOpen = _a.isOpen, confirmActionText = _a.confirmActionText, onConfirmAction = _a.onConfirmAction, children = _a.children;
    return (React.createElement(AlertDialog, { isOpen: isOpen, title: title, confirmActionText: confirmActionText, onConfirmAction: onConfirmAction, iconStatus: "error" }, children));
};
export default ErrorDialog;
